import React, { useState } from 'react';
import { useQuery } from 'react-query';
import styled from 'styled-components';

import PreviewDropDown from 'components/previewPages/PreviewDropDown';
import { getDepartmentList } from 'components/previewPages/PreviewService';

import { FormInput, FormLabel, InputContainerWrapper } from './StyledElements';

type Props = {
  isDesktop: boolean;
  includeDepartment: boolean;
  label: string;
};

const OfferCodeForm = ({ isDesktop, label, includeDepartment }: Props) => {
  const [isInputActive, setIsInputActive] = useState(false);

  const departmentList = useQuery([], getDepartmentList).data || [];

  return (
    <FormWrapper>
      {includeDepartment && (
        <PreviewDropDown
          textLabel="Select your department"
          data={departmentList}
          isDesktop={isDesktop}
        />
      )}

      <InputContainerWrapper $isDesktop={isDesktop}>
        <FormLabel $isActive={isInputActive} $isDesktop={isDesktop}>
          {label}
        </FormLabel>
        <FormInput
          onFocus={() => setIsInputActive(true)}
          $isDesktop={isDesktop}
        />
      </InputContainerWrapper>
    </FormWrapper>
  );
};

const FormWrapper = styled.div`
  position: absolute;
  bottom: 40px;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default OfferCodeForm;
